<template>
  <el-header id="navbar">
    <el-row>
      <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
        <router-link :to="'/'"><div class="logo"></div></router-link></el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-row type="flex" justify="center">
            <el-menu mode="horizontal" :router="false">
              <!-- <el-menu-item index="1" :route="{ path: getFullUrl($t('MainPage.MainMenu.add_your_business')) }">{{ $t('MainPage.MainMenu.add_your_business') }} <i class="el-icon-circle-plus el-icon--right"></i></el-menu-item> -->
              <el-menu-item index="1" @click="contactDialogVisible = true">{{ $t('MainPage.MainMenu.add_your_business') }} <i class="el-icon-circle-plus el-icon--right"></i></el-menu-item>
              <!-- <el-menu-item index="1" :route="{ path: getFullUrl($t('MainPage.MainMenu.login')) }">{{ $t('MainPage.MainMenu.login') }}</el-menu-item> -->
              <!-- <el-menu-item index="3" :route="{ path: getFullUrl($t('MainPage.MainMenu.signup')) }">{{ $t('MainPage.MainMenu.signup') }}</el-menu-item> -->
              <!-- <el-menu-item index="5" :route="{ path: getFullUrl($t('MainPage.MainMenu.add_button_label')) }">{{ $t('MainPage.MainMenu.add_button_label') }}</el-menu-item> -->
            </el-menu>
            <div class="language-selector">
              <el-dropdown @command="setLang">
                <span class="el-dropdown-link">
                  <img :src="getFlagImagePath()" />
                  <!-- <i class="el-icon-view el-icon--right"></i> -->
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="es-AR"><img src="@/assets/img/es-AR.png" /> Argentina</el-dropdown-item>
                  <el-dropdown-item command="pt-BR"><img src="@/assets/img/pt-BR.png" /> Brasil</el-dropdown-item>
                  <el-dropdown-item command="es-CL"><img src="@/assets/img/es-CL.png" /> Chile</el-dropdown-item>
                  <el-dropdown-item command="en-US"><img src="@/assets/img/en-US.png" /> EEUU</el-dropdown-item>
                  <el-dropdown-item command="es-ES"><img src="@/assets/img/es-ES.png" /> España</el-dropdown-item>
                  <el-dropdown-item command="es-MX"><img src="@/assets/img/es-MX.png" /> México</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-row>
        </el-col>
      </el-row>

      <el-dialog title="Ingrese su comercio ahora ya" :visible.sync="contactDialogVisible">
        <p>Complete los siguientes datos para contactarlo a la brevedad</p>
        <el-form :model="form" :rules="rules" ref="contactForm">
          <el-form-item label="Nombre" prop="name">
            <el-input v-model="form.name" type="text"></el-input>
          </el-form-item>
          <el-form-item label="Correo" prop="email">
            <el-input v-model="form.email" type="email"></el-input>
          </el-form-item>
          <el-form-item label="Telefono" prop="phone">
            <el-input v-model="form.phone" type="text"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="contactDialogVisible = false">Cancelar</el-button>
          <el-button type="primary" @click="submitForm('contactForm')">Confirmar</el-button>
        </span>
      </el-dialog>
    </el-header>
  </template>
<script>
import axios from 'axios';

export default {
  name: 'Header',
  data() {
    return {
      activeIndex: '1',
      activeIndex2: '1',
      form:{
        name: '',
        email: '',
        phone: ''
      },
      contactDialogVisible: false,
      rules: {
          name: [
            { required: true, message: 'Por favor ingrese su nombre.', trigger: 'blur' },
            { min: 3, max: 50, message: 'Largo del texto debe estar entre los 3 y 50 caracteres.', trigger: 'blur' }
          ],
          email: [
            { required: true, message: 'Por favor ingrese su email', trigger: 'blur' },
            { min: 10, max: 50, message: 'Largo del texto debe estar entre los 10 y 50 caracteres.', trigger: 'blur' }
          ],
          phone: [
            { required: true, message: 'Por favor ingrese su telefono', trigger: 'blur' },
            { min: 10, max: 50, message: 'Largo del texto debe estar entre los 10 y 50 caracteres.', trigger: 'blur' }
          ],
      }
    };
  },
  methods: {
    submitForm(formName) {
      let self = this;

      this.$refs[formName].validate((valid) => {
        if (valid) {
          self.$store.dispatch("saveProspectForm",{ data: {
            name: self.form.name,
            email: self.form.email,
            phone: self.form.phone,
            channel: 'main-businesses-directory-website',
          }}).then(response => {
            this.$message({
              type: 'success',
              message: 'Su email ha sido ingresado, agradecemos su tiempo.'
            });
            self.resetForm('contactForm');
            self.contactDialogVisible = false;
          }).catch(error => {
            this.$message({
              type: 'info',
              message: error
            });
          });

          axios.post('https://info.cryptomkt.com/notifications', {
            name: self.form.name,
            phone: self.form.phone,
            email: self.form.email,
            source: 'comercios.cryptocompra.com'
          })
          .then(function (response) {
            console.log(response);
          })
          .catch(function (error) {
            console.log(error);
          });

        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    saveProspect(email) {
      let self = this;
      self.$store.dispatch("saveProspectForm",{ data: {
        email: email,
        channel: 'main-businesses-directory-website',
      }}).then(response => {
        self.form.view = false;
      }).catch(error => {
        console.log(error);
      });
    },
    sendEmailForm(){
      let self = this;

      self.$store.dispatch("saveProspectForm",{ data: {
        name: self.form.name,
        email: self.form.email,
        phone: self.form.phone,
        channel: 'main-businesses-directory-website',
      }}).then(response => {
        this.$message({
          type: 'success',
          message: 'Su email ha sido ingresado, agradecemos su tiempo.'
        });
      }).catch(error => {
        this.$message({
          type: 'info',
          message: error
        });
      });
    },
    openEmailForm() {
      let self = this;

      this.$prompt('Por favor ingrese su email, lo contactaremos a la brevedad.', 'Ingrese su comercio', {
        confirmButtonText: 'Enviar',
        cancelButtonText: 'Cancelar',
        inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: 'Email invalido'
      }).then(({ value }) => {

        self.$store.dispatch("saveProspectForm",{ data: {
          email: value,
          channel: 'main-businesses-directory-website',
        }}).then(response => {
          this.$message({
            type: 'success',
            message: 'Su email ha sido ingresado, agradecemos su tiempo.'
          });
        }).catch(error => {
          this.$message({
            type: 'info',
            message: error
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Ingreso cancelado'
        });
      });
    },
    getFlagImagePath(){
      // return require('@/assets/img/'+this.getLang()+'.png');
      return require("@/assets/img/"+this.getLang()+".png")
    },
    handleSelect(key, keyPath) {
        // console.log(key, keyPath);
    },
    getFullUrl(value){
      function removeAccents(str) {
        let accents = 'ÀÁÂÃÄÅàáâãäåßÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
        let accentsOut = "AAAAAAaaaaaaBOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
        str = str.split('');
        str.forEach((letter, index) => {
          let i = accents.indexOf(letter);
          if (i != -1) {
            str[index] = accentsOut[i];
          }
        })
        return str.join('');
      }

      if(this.$store){
        return '/'+this.$store.getters['lang/getShortLang']+'/' + removeAccents(value).toLowerCase()
      }

    },
    setLang: function(lang){
      this.$store.dispatch('lang/setLang', lang)
      this.$router.push('/'+this.getLongLang());
    },
    getLang: function (){
      return this.$store.getters['lang/getLang']
    },
    getShortLang: function (){
      return this.$store.getters['lang/getShortLang']
    },
    getLongLang: function (){
      return this.$store.getters['lang/getLongLang']
    },
  },
  mounted(){
    if(this.$router.currentRoute.fullPath === '/'){
        window.onscroll = () => {
          const nav = document.querySelector('#navbar'); //console.log(window.scrollY)
          if(window.scrollY <= 500){
            nav.classList.remove("color-style");
          }
          else{
            nav.classList.add("color-style");
          }
        };
    }

    let self = this;
    if(this.$route.params.country && _.isEmpty(this.$route.params.city)){
      switch(this.$route.params.country){
        case 'argentina':
        self.setLang('es-AR');
        break;
        case 'brasil':
        self.setLang('pt-BR');
        break;
        case 'chile':
        self.setLang('es-CL');
        break;
        case 'eeuu':
        self.setLang('en-US');
        break;
        case 'espana':
        self.setLang('es-ES');
        break;
        case 'mexico':
        self.setLang('es-MX');
        break;
        default:
        self.setLang('es-CL');
      }
    }
  }
};
</script>
<style scoped>
/* xs and down */
@media only screen and (max-width: 768px) {
  header{
    height: auto !important;
    /* background: none !important; */

    /* background: linear-gradient(to bottom, rgba(255,255,255,1) 0%,rgba(255,255,255,1) 72%,rgba(255,255,255,0) 100%) !important; /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */ */
    .el-menu--horizontal > .el-menu-item{
      color: grey;
    }
    .el-menu-item{
        color: grey !important;
    }
    .el-menu-item.is-active {
        color: black !important;
    }
    position: relative;
    /* div.logo{
        background-image: url(../../assets/img/logo-1.png) !important;
    } */
  }
}

header{
  width: 100%;
  position: fixed;
  background-color: #1e1e1e;
  /* background: linear-gradient(to bottom, rgba(0,0,0,1) 0%,rgba(0,0,0,0.5) 70%,rgba(0,0,0,0) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */ */
  transition: background-color 0.4s ease-out;
  z-index: 10;
  /* border-bottom: 1px solid grey; */
  .el-menu{
    background-color: inherit;
    .el-menu-item:hover, .el-menu-item:focus {
        background: none;
    }
  }
}
header.el-header{
    .el-row, .el-col{ height: 100% }
    div.logo{
        background-image: url(../../assets/img/logo-white.png);
        background-position: center center;
        background-repeat: no-repeat;
        margin: 1rem 0;
        height: 1.7rem;
        background-size: contain;
    }
  .language-selector{
    /* display: none; */
    /* width: 6vw; */
    /* color: white; */
    padding: 2vh 0;
    .el-dropdown-menu__item{
      /* color: black */
    }
    div.language{
      /* height: 2vh; */
      /* width: 2vh; */
      padding: 0.1rem;
      border: solid white 1px;
      font-size: 0.8rem;
      display: inline-block;
      cursor: pointer;
    }
    .el-dropdown-link img{
      max-height: 3vh
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/merchants/Header.vue